import { useURLSearchParams } from './use_url_search_params';

export const useURLSearchParam = <T extends string = string>(name: string, fallback: T | undefined = undefined) => {
  const [params, onChange] = useURLSearchParams();

  const value = (params.get(name) as T | undefined) ?? fallback;

  return [
    value,
    (value: T | undefined) => {
      onChange((params) => {
        if (value && value !== fallback) params.set(name, value);
        else params.delete(name);
        return params;
      });
    },
  ] as const;
};
